import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { getCompactSelectStyles, Select } from '@/shared/ui';

import styles from './MicrophoneSetting.module.scss';

type Props = {
  options: { value: string; label: string }[];
  value: string;
  disabled: boolean;
  status: ReactNode;
  ready: boolean;
  className?: string;
  onChange: (value: string) => void;
};

export const MicrophoneSetting: FC<Props> = ({
  options,
  value,
  disabled,
  status,
  ready,
  className,
  onChange,
}) => (
  <div className={cn(styles.microphone, className)}>
    <span className={cn('p4', styles.label)}>
      <FormattedMessage id="workspace.microphone" defaultMessage="Microphone" />
    </span>
    <Select
      styles={getCompactSelectStyles()}
      isSearchable={false}
      isDisabled={disabled}
      options={options}
      value={value}
      onChange={(next) => {
        if (typeof next === 'string') {
          onChange(next);
        }
      }}
    />
    <span className={cn('p4', styles.status, ready && styles.ready)}>
      {status}
    </span>
  </div>
);
